// ProjectCarousel.js
import { React, useState } from "react";
import "./projects.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { useProject } from "../../providers/projectProvider";
import { Autoplay, Pagination, Navigation, Zoom } from "swiper/modules";

import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { TickProject } from "./projectTick";

const ProjectCarousel = () => {
  const { getCurrentProject, currentProjectId } = useProject();
  const currentProject = getCurrentProject();
  const [loading, setLoading] = useState(
    new Array(currentProject.images.length).fill(true)
  );

  const handleImageLoad = (index) => {
    setLoading((prevLoading) => {
      const newLoading = [...prevLoading];
      newLoading[index] = false;
      return newLoading;
    });
  };

  return (
    <>
      <div className="carousel-container mt-5 position-relative">
        <Reveal revealSecondDiv={true} widthClass="w-fit">
          <h1
            id="project-preview"
            className="font-neue text-white about-heading"
          >
            Work Preview
          </h1>
        </Reveal>

        <Reveal revealSecondDiv={true}>
          <AnimatePresence mode="wait">
            <motion.div
              id="projectPreview"
              key={currentProjectId}
              initial={{ x: 10, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <Swiper
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                autoplay={{
                  delay: 6000,
                  disableOnInteraction: true,
                }}
                zoom={true}
                pagination={{
                  clickable: true,
                  type: "progressbar",
                }}
                modules={[Autoplay, Pagination, Navigation, Zoom]}
                className="mySwiper mt-3"
              >
                {currentProject.images.map((imageUrl, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="swiper-zoom-container"
                      style={{
                        backgroundColor: "transparent",
                        height: "auto",
                      }}
                    >
                      {loading[index] && (
                        <div
                          style={{
                            display: "grid",
                            placeItems: "center",
                            width: "100%",
                            height: "660px",
                            color: "#fff",
                          }}
                        >
                          <h1>Loading...</h1>{" "}
                        </div>
                      )}
                      {imageUrl && (
                        <img
                          onLoad={() => handleImageLoad(index)}
                          src={imageUrl}
                          style={{
                            width: "100%",
                            maxHeight: "90vh",
                          }}
                          alt={`Project ${index + 1}- ${imageUrl}`}
                        />
                      )}
                    </div>
                  </SwiperSlide>
                ))}
                {currentProject.media  && currentProject.media.map((media, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="swiper-zoom-container"
                      style={{
                        backgroundColor: "transparent",
                        height: "auto",
                      }}
                    >
                      {loading[index] && (
                        <div
                          style={{
                            display: "grid",
                            placeItems: "center",
                            width: "100%",
                            height: "660px",
                            color: "#fff",
                          }}
                        >
                          <h1>Loading...</h1>{" "}
                        </div>
                      )}
                      {media && (
                        <video
                          src={media}
                          autoPlay
                          loop
                          muted
                          style={{
                            width: "100%",
                            maxHeight: "90vh",
                          }}
                          alt={`Project ${index + 1}- ${media}`}
                        />
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </motion.div>
          </AnimatePresence>
        </Reveal>
        <TickProject />

        <Reveal>
          <AnimatePresence mode="wait">
            {currentProject && (
              <motion.div
                key={currentProject.id}
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -10, opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="row mt-2 align-items-start font-roobert text-uppercase project-details"
              >
                <div className="col-lg-6 col-md-12 col-sm-12">
                  <div
                    style={{
                      textAlign: "start",
                      textTransform: "uppercase",
                      height: "fit-content",
                    }}
                  >
                    <p className="m-0">
                      <strong className="text-opacity">Title</strong>{" "}
                      {currentProject.name}
                    </p>
                    <p className="m-0">
                      <strong className="text-opacity">technologies</strong>{" "}
                      {currentProject.technologies}
                    </p>
                    <p className="m-0">
                      <strong className="text-opacity">category</strong>{" "}
                      {currentProject.category}
                    </p>
                  </div>
                </div>
                <div className="col-lg-5 col-12">
                  <p className="m-0" >{currentProject.description}</p>
                  {currentProject.preview !== undefined && (
                    <div className="m-0 d-flex ">
                      <strong className="text-opacity">Preview</strong>
                      {currentProject.preview === "" ? (
                        <p style={{ marginLeft: 1 }}>Currently not hosted.</p>
                      ) : (
                        <a
                          style={{
                            marginLeft: 1,
                          }}
                          className="text-white chonkyunderline_black"
                          href={currentProject.preview}
                        >
                          {currentProject.preview}
                        </a>
                      )}
                    </div>
                  )}
                  {currentProject.source_code !== undefined && (
                    <p className="text-white m-0 d-flex">
                      <strong className="text-opacity">Source Code</strong>{" "}
                      <a
                        className="text-white chonkyunderline_black"
                        href={currentProject.source_code}
                      >
                        <em> {currentProject.source_code} </em>
                      </a>
                    </p>
                  )}
                  {currentProject.apk_file !== undefined && (
                    <p className="m-0">
                      <strong className="text-opacity">APK FILE </strong>
                      {currentProject.apk_file === ""
                        ? "The APK file is available for demonstration purposes and can be provided upon request."
                        : currentProject.apk_file}{" "}
                    </p>
                  )}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </Reveal>
      </div>
    </>
  );
};

export default ProjectCarousel;
